module.exports = __webpack_public_path__ + "img/select02.64192ac6.png";